module.exports = __webpack_public_path__ + "img/landing_header_image.428a14a3.jpg";